"use client";

import React from "react";
import { ArrowDown } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LegalHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const lavenderColor = "hsl(273 25% 70%)";
  return <section id="legal-hero" className="relative min-h-[85vh] w-full flex items-center justify-center overflow-hidden bg-background">
      <style>{`
        .heading-lavender-italic {
          color: ${lavenderColor};
          font-style: italic;
          font-weight: 600;
          font-family: serif;
        }
      `}</style>

      <div className="absolute inset-0 z-0">
        <img src="https://picked-skylark-1.10web.cloud/wp-content/uploads/2026/04/hero_forest_privacy.webp" alt="Lichtdurchfluteter Wald Soonwald" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-white/40 backdrop-blur-[1px]" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background" />
      </div>

      <div ref={ref} className={`relative z-10 container mx-auto px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h1 className="text-foreground text-5xl md:text-7xl lg:text-8xl font-serif font-regular leading-[1.1] tracking-wider mb-8 uppercase">
          Klarheit & <br />
          <span className="heading-lavender-italic">Transparenz</span>
        </h1>

        <p className="text-muted-foreground font-sans text-lg md:text-xl max-w-2xl mx-auto leading-relaxed font-light mb-12 uppercase tracking-[0.2em]">
          Impressum und Rechtliches
        </p>

        <div className="flex flex-col items-center gap-4 text-primary/60 font-mono text-[10px] tracking-[0.3em] uppercase">
          <span className="animate-pulse">Details entdecken</span>
          <ArrowDown className="w-5 h-5 animate-bounce" />
        </div>
      </div>
    </section>;
}